import { INavLink } from "@fluentui/react";
import { getAppRoutesArray } from "./app-routes";
import { where } from "../framework/utils/collection";
import { IAdminAppRoute } from "./admin-app-route";

const linkable = where(getAppRoutesArray(), r => r.topLevel && !!r.sideMenuLabel);

export const AppLinks: INavLink[] = linkable.map(r => {
  const route = r as IAdminAppRoute<() => string>;
  return {
    name: route.sideMenuLabel!,
    url: route.url(),
    key: route.key,
    icon: route.icon,
  };
});